// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.9996 3C6.42102 3 1.69842 6.65364 0.0892162 11.696L-0.0078125 12L0.0892162 12.304C1.69842 17.3464 6.42102 21 11.9996 21C17.5781 21 22.3007 17.3464 23.9099 12.304L24.007 12L23.9099 11.696C22.3007 6.65364 17.5781 3 11.9996 3ZM12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-browse-filled')
export default class BrowseFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'browse-filled',
    }
  }
}
